import { C as CheckRadioMixin } from './CheckRadioMixin-I9QgrPGQ.js';
import { openBlock, createElementBlock, normalizeClass, withKeys, withModifiers, withDirectives, createElementVNode, vModelRadio, renderSlot } from 'vue';
import { a as registerComponent } from './plugins-C7548x21.js';

var script$1 = {
    name: 'BRadio',
    mixins: [CheckRadioMixin]
};

const _hoisted_1$1 = ["disabled"];
const _hoisted_2$1 = ["disabled", "required", "name", "value"];
const _hoisted_3 = { class: "control-label" };

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("label", {
    class: normalizeClass(["b-radio radio", [_ctx.size, { 'is-disabled': _ctx.disabled }]]),
    ref: "label",
    disabled: _ctx.disabledOrUndefined,
    onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.focus && _ctx.focus(...args))),
    onKeydown: _cache[3] || (_cache[3] = withKeys(withModifiers($event => (_ctx.$refs.label.click()), ["prevent"]), ["enter"]))
  }, [
    withDirectives(createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.computedValue) = $event)),
      type: "radio",
      ref: "input",
      onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"])),
      disabled: _ctx.disabledOrUndefined,
      required: _ctx.requiredOrUndefined,
      name: _ctx.name,
      value: _ctx.nativeValue
    }, null, 8 /* PROPS */, _hoisted_2$1), [
      [vModelRadio, _ctx.computedValue]
    ]),
    createElementVNode("span", {
      class: normalizeClass(["check", _ctx.type])
    }, null, 2 /* CLASS */),
    createElementVNode("span", _hoisted_3, [
      renderSlot(_ctx.$slots, "default")
    ])
  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1$1))
}

script$1.render = render$1;
script$1.__file = "src/components/radio/Radio.vue";

var script = {
    name: 'BRadioButton',
    mixins: [CheckRadioMixin],
    props: {
        type: {
            type: String,
            default: 'is-primary'
        },
        expanded: Boolean
    },
    data() {
        return {
            isFocused: false
        }
    },
    computed: {
        isSelected() {
            return this.newValue === this.nativeValue
        },
        labelClass() {
            return [
                this.isSelected ? this.type : null,
                this.size,
                {
                    'is-selected': this.isSelected,
                    'is-disabled': this.disabled,
                    'is-focused': this.isFocused
                }
            ]
        }
    }
};

const _hoisted_1 = ["disabled"];
const _hoisted_2 = ["disabled", "required", "name", "value"];

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (openBlock(), createElementBlock("div", {
    class: normalizeClass(["control", { 'is-expanded': $props.expanded }])
  }, [
    createElementVNode("label", {
      class: normalizeClass(["b-radio radio button", $options.labelClass]),
      ref: "label",
      disabled: _ctx.disabledOrUndefined,
      onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.focus && _ctx.focus(...args))),
      onKeydown: _cache[5] || (_cache[5] = withKeys(withModifiers($event => (_ctx.$refs.label.click()), ["prevent"]), ["enter"]))
    }, [
      renderSlot(_ctx.$slots, "default"),
      withDirectives(createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.computedValue) = $event)),
        type: "radio",
        ref: "input",
        onClick: _cache[1] || (_cache[1] = withModifiers(() => {}, ["stop"])),
        disabled: _ctx.disabledOrUndefined,
        required: _ctx.requiredOrUndefined,
        name: _ctx.name,
        value: _ctx.nativeValue,
        onFocus: _cache[2] || (_cache[2] = $event => ($data.isFocused = true)),
        onBlur: _cache[3] || (_cache[3] = $event => ($data.isFocused = false))
      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_2), [
        [vModelRadio, _ctx.computedValue]
      ])
    ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_1)
  ], 2 /* CLASS */))
}

script.render = render;
script.__file = "src/components/radio/RadioButton.vue";

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script$1);
    registerComponent(Vue, script);
  }
};

export { script$1 as BRadio, script as BRadioButton, Plugin as default };
